<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>Learner Quota History </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="org" :items="org_list" item-text="name" return-object label="Organization" outlined></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-btn rounded class="button mt-6"  @click="getAllReport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
                <v-col cols="12" sm="12" md="12" v-if="learner_list!=''"> 
            <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Learners </v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br>
                <v-data-table :items="learner_list" :headers="headers" class="elevation-1 mytable" dense></v-data-table>

              <center>  <v-btn rounded class="button mt-6"  @click="save()" :loading="save_loader">Sync Learner Quota</v-btn> </center>
           </v-col>
          
        </v-card>
    </div>
  </template>
  <script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                org_list: null,
                org: "",
                org_data_list: [],
                org_data: [],
                fetch_loader: false,
                save_loader:false,
                learner_list:[],
                headers: [
                { text: "Registration Number", value: "registration_number", sortable: true },
                { text: "Name", value: "name", sortable: true },
                { text: "Organization", value: "org", sortable: true },
            ],
            };
        },
        methods: {
          
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async save(){
                this.save_loader = true
                const data = {
                    learners:this.learner_list
                }
                try {
                    const res = await axios.post("/AccountingAndFees/saveLearnerQuotaHistory", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Saved Successfully");
                       this.save_loader = false
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.save_loader = false
                    }
                    this.save_loader = false
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.save_loader = false
                } finally {
                    this.save_loader = false
                }
            },
            async getAllReport(){
                this.learner_list = []
                this.fetch_loader = true
                const data = {
                    org:this.org.id
                }
                try {
                    const res = await axios.post("/AccountingAndFees/getOrgLearner", data);
                    if (res.data.flag == "YES") {
                       this.learner_list = res.data.learner_list
                       this.fetch_loader = false
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.fetch_loader = false
                    }
                    this.fetch_loader = false
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.fetch_loader = false
                } finally {
                    this.fetch_loader = false
                }
            },
            onload() {
                axios
                    .post("/Management/getOrg")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
  </script>
  <style scoped>
    
  </style>
  